if (!customElements.get('terms-acceptance')) {
  class TermsAcceptance extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.checkbox = this.querySelector('.terms-acceptance__checkbox');
      this.timestamp = this.querySelector('.terms-acceptance__timestamp');
      this.form = document.getElementById(this.dataset.formId);

      if (!this.checkbox || !this.timestamp) return;

      this.updateTimestamp = () => {
        this.timestamp.value = this.checkbox.checked ? new Date().toISOString() : '';
      };

      this.checkbox.addEventListener('change', this.updateTimestamp);

      if (this.form) {
        this.form.addEventListener('submit', () => {
          if (this.checkbox.checked && !this.timestamp.value) {
            this.timestamp.value = new Date().toISOString();
          }
        });
      }
    }
  }

  customElements.define('terms-acceptance', TermsAcceptance);
}
